import { atom } from 'recoil'
import { DealTypes } from 'services'

export const dealsList = atom<DealTypes[]>({
  key: 'dealsList',
  default: []
})
